import Divider from "components/Divider";
import useSummary from "./hooks/useSummary";
import Message from "./components/Message";
import Blockquote from "components/Blockquote";
import LoadingPage from "components/LoadingPage";
import Information from "./components/Information";
import Indications from "./components/Indications";
import { Button } from "@utp/react-components-prod";
import ModalInternet from "components/ModalInternet";
import HeaderSummary from "./components/HeaderSummary";
import ModalErrorServer from "components/ModalErrorServer";
import ModalConfirmation from "./components/ModalConfirmation";
import { getButtonText, getClassButton } from "./constanst";
import NotAssigned from "./components/NotAssigned";

const SummaryBase = () => {
  const {
    isError,
    status,
    isLoading,
    isOpenModal,
    timeSummary,
    dateSummary,
    isManyError,
    isScheduled,
    isInProgress,
    titleSummary,
    isMinorTablet,
    isNotAssigned,
    statusSummary,
    durationSummary,
    getConfigModal,
    instructionsSummary,
    totalQuestionSummary,
    handleRedirectToEvaluation,
  } = useSummary();

  if (isNotAssigned) {
    return <NotAssigned />;
  }

  if (isLoading) {
    return <LoadingPage isLoading={isLoading} />;
  }
  return (
    <div className="bg-02 p-8 overflow-auto scroll-modified" data-testid="summary-page">
      <div className="bg-01 p-8 rounded-sm max-w-base m-auto">
        <HeaderSummary
          isMobile={isMinorTablet}
          statusSummary={status}
          titleSummary={titleSummary}
          isVisibleStatus={!isScheduled}
        />

        <Divider />

        <Information
          isMobile={isMinorTablet}
          timeSummary={timeSummary}
          dateSummary={dateSummary}
          durationSummary={durationSummary}
          totalQuestionSummary={totalQuestionSummary}
        />

        <Divider />

        <Indications instructionsSummary={instructionsSummary} />

        <Blockquote isCenterFlex={isScheduled}>
          <ul className={!isScheduled ? "list-disc ml-3" : "ml-0"}>
            <Message typeStatus={statusSummary} />
          </ul>
        </Blockquote>

        <Button
          color="primary"
          text={getButtonText(isInProgress)}
          data-testid="button-redirect-to-evaluation"
          onClick={() => handleRedirectToEvaluation()}
          className={getClassButton(isMinorTablet, isScheduled)}
        />

        <ModalConfirmation
          isOpen={isOpenModal("confirmation")}
          config={getConfigModal("confirmation")}
        />

        <ModalErrorServer isOpen={isError} isManyError={isManyError} />

        <ModalInternet isOpen={isOpenModal("internet")} />
      </div>
    </div>
  );
};

export default SummaryBase;
